module.exports = __webpack_public_path__ + "static/media/arrow_right.4b50940d.svg";